import {ICrudOptions} from './crud';

//#region INTERFACE IUserAccessUserTableSettings
export interface IUserAccessUserTableSettings {
  enterNavigationMode: ICrudOptions;
  ngpPreview: ICrudOptions;
  stockPreview: ICrudOptions;
  tabNavigationMode: ICrudOptions;
}

//#endregion

//#region CONST _DEFAULT_USER_ACCESS_ENTER_NAVIGATION
export const _DEFAULT_USER_ACCESS_ENTER_NAVIGATION: Readonly<ICrudOptions & Object> = {
  canEdit: true,
  canSubmit: true,
  canView: true,
  isEdited: false,
};
//#endregion

//#region CONST _DEFAULT_USER_ACCESS_TAB_NAVIGATION
export const _DEFAULT_USER_ACCESS_TAB_NAVIGATION: Readonly<ICrudOptions & Object> = {
  canEdit: true,
  canSubmit: true,
  canView: true,
  isEdited: false,
};
//#endregion

//#region CONST _DEFAULT_USER_ACCESS_NGP_PREVIEW_COLUMNS
export const _DEFAULT_USER_ACCESS_NGP_PREVIEW_COLUMNS: Readonly<ICrudOptions & Object> = {
  canEdit: true,
  canSubmit: true,
  canView: true,
  isEdited: false,
};
//#endregion

//#region CONST _DEFAULT_USER_ACCESS_STOCK_PREVIEW_COLUMNS
export const _DEFAULT_USER_ACCESS_STOCK_PREVIEW_COLUMNS: Readonly<ICrudOptions & Object> = {
  canEdit: true,
  canSubmit: true,
  canView: true,
  isEdited: false,
};
//#endregion

//#region CONST _DEFAULT_USER_ACCESS_USER_TABLE_SETTINGS
export const _DEFAULT_USER_ACCESS_USER_TABLE_SETTINGS: Readonly<IUserAccessUserTableSettings & Object> = {
  enterNavigationMode: _DEFAULT_USER_ACCESS_ENTER_NAVIGATION,
  tabNavigationMode: _DEFAULT_USER_ACCESS_TAB_NAVIGATION,
  ngpPreview: _DEFAULT_USER_ACCESS_NGP_PREVIEW_COLUMNS,
  stockPreview: _DEFAULT_USER_ACCESS_STOCK_PREVIEW_COLUMNS,
};
//#endregion
